import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../components/PageConfigProvider/constants';
import type { TabContent } from '../components/PageConfigProvider/page-reducer';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../components/PageConfigProvider/types';
import { PlotFilterType } from '../components/PageConfigProvider/types/item';
import { FilterId } from '../filters/types/filters';

const items: TabContent['items'] = [
  {
    position: { x: 0, width: 32, y: 0, height: 18 },
    id: 'role-overview-summary',
    title: null,
    isTitleManuallySet: true,
    info: {
      text: 'Descriptions are sourced from AI generated text.',
    },
    plot: {
      chartType: 'entity-summary',
      defaultMetricOptions: ['entity_summary'],
    },
  },
  {
    position: { x: 0, width: 16, y: 18, height: 18 },
    id: 'role-overview-top-skills',
    title: 'Top Skills',
    info: {
      text: 'Skills distribution of this role',
    },
    plot: {
      chartType: 'bar',
      defaultMetricOptions: ['headcount'],
      dimensionSource: 'skills',
      plotFilters: [{ type: PlotFilterType.TOP_N, value: 7 }],
      hideOther: true,
    },
  },
  {
    position: { x: 16, width: 16, y: 18, height: 18 },
    id: 'role-overview-top-geographies',
    title: 'Top Geographies',
    info: {
      text: 'Geographic distribution of this role',
    },
    plot: {
      chartType: 'bar',
      defaultMetricOptions: ['headcount'],
      dimensionSource: 'geography',
      plotFilters: [{ type: PlotFilterType.TOP_N, value: 7 }],
      hideOther: true,
    },
  },
  {
    position: { x: 32, width: 16, y: 18, height: 18 },
    id: 'role-overview-top-rics',
    title: 'Top Industries',
    info: {
      text: 'Distribution of companies by industry for this role',
    },
    plot: {
      chartType: 'bar',
      defaultMetricOptions: ['headcount'],
      dimensionSource: 'rics',
      plotFilters: [{ type: PlotFilterType.TOP_N, value: 7 }],
      hideOther: true,
    },
  },
  {
    position: { x: 32, width: 16, y: 0, height: 18 },
    id: 'role-overview-stats',
    title: null,
    isTitleManuallySet: true,
    plot: {
      chartType: 'mixed-stats',
      defaultMetricOptions: [],
    },
  },
];

const roleOverviewTab: TabContent = {
  id: 'role-overview',
  items,
  primaryFilter: {
    id: FilterId.ROLE,
    selectionLimit: 1,
    selectionDefault: 1,
  },
  grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
  secondaryFilters: [
    FilterId.SENIORITY,
    FilterId.SKILL,
    FilterId.CUSTOM_SKILL,
    FilterId.COMPANY,
    FilterId.GEOGRAPHY,
    FilterId.CONTINGENT_WORKERS,
  ].map((id) => ({ id })),
  dateRangeDefault: 'last-year',
};

export const roleOverview: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.ROLE_OVERVIEW,
  revelioPageId: RevelioPageId.ROLE_OVERVIEW,
  name: 'Overview',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'role-overview',
      label: 'Overview',
      tabContent: roleOverviewTab,
      isActive: true,
    },
  ],
};
